var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6020_11686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 5H6.5L19 13.5H36V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z",
    fill: "#DE3830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 31H32C33.0609 31 34.0783 30.5786 34.8284 29.8284C35.5786 29.0783 36 28.0609 36 27V22.5H19L6.5 31Z",
    fill: "#002395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11V25L10.5 18L0 11Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9V11L10.5 18L0 25V27L13.5 18L0 9Z",
    fill: "#FFB611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.541 5.02802C2.56637 5.1406 1.6671 5.60745 1.01422 6.3398C0.361343 7.07215 0.000386962 8.0189 0 9.00002L13.5 18L0 27C0.000386962 27.9811 0.361343 28.9279 1.01422 29.6602C1.6671 30.3926 2.56637 30.8594 3.541 30.972L18.5 20.5H36V15.5H18.5L3.541 5.02802Z",
    fill: "#007A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50002 5H4.00002C3.84402 5 3.69202 5.011 3.54102 5.028L18.5 15.5H36V13.5H19L6.50002 5ZM3.54102 30.972C3.69202 30.989 3.84402 31 4.00002 31H6.50002L19 22.5H36V20.5H18.5L3.54102 30.972Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6020_11686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/sa.06ef9a87.svg";
export { ForwardRef as ReactComponent };